// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__27npA","fileBtn":"File_fileBtn__2SVJl","closeBtn":"File_closeBtn__2E2OY","fileSelected":"File_fileSelected__B0dwo","disabled":"File_disabled__3OvpM"};